import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import { starterKitBuyNow, starterKitBuyNow1, advencedKitBuyNow, smartContralKitBuyNow } from '../utils/constant';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/');

export default function E({ SHOW_TS_BUNDLE_SITE }: any): JSX.Element {
    const { useLang, Link, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [curIndex, setCurIndex] = useState<number>(0);
    const [left, setLeft] = useState(0);
    const [disable, setDisable] = useState('prev');
    const itemsMap: any = {
        us: [
            {
                title_1: t('secE_item1_title_1'),
                title_2: t('secE_item1_title_2'),
                title_3: t('secE_item1_title_3'),
                title_4: t('secE_item1_title_4'),
                img: 'pc/ef_1',
                targetElement: '.landing_page_F',
                top: 0,
                buyNowLink: starterKitBuyNow.replace('https://us', `https://${locale}`),
            },
            {
                title_1: t('secE_item4_title_1'),
                title_2: t('secE_item4_title_2'),
                title_3: t('secE_item4_title_3'),
                title_4: t('secE_item4_title_4'),
                img: 'pc/ef_2',
                targetElement: '.landing_page_F1',
                top: 0,
                buyNowLink: starterKitBuyNow1.replace('https://us', `https://${locale}`),
            },
            {
                title_1: t('secE_item2_title_1'),
                title_2: t('secE_item2_title_2'),
                title_3: t('secE_item2_title_3'),
                title_4: t('secE_item2_title_4'),
                img: 'pc/g-5',
                targetElement: '.landing_page_G',
                top: 0,
                buyNowLink: advencedKitBuyNow.replace('https://us', `https://${locale}`),
            },
            {
                title_1: t('secE_item3_title_1'),
                title_2: t('secE_item3_title_2'),
                title_3: t('secE_item3_title_3'),
                title_4: t('secE_item3_title_4'),
                img: 'pc/e-1',
                targetElement: '.scroll-trigger-origin-H2',
                top: 0,
                buyNowLink: smartContralKitBuyNow.replace('https://us', `https://${locale}`),
            },
        ],
        ca: [
            {
                title_1: t('secE_item4_title_1'),
                title_2: t('secE_item4_title_2'),
                title_3: t('secE_item4_title_3'),
                title_4: t('secE_item4_title_4'),
                img: 'DPU+TS(30A)',
                targetElement: '.landing_page_F0',
                top: 52,
                // buyNowLink: 'https://ca.ecoflow.com/cart/44244774650010:1,44286204903578:1?channel=buy_button',
                buyNowLink: 'https://ca.ecoflow.com/pages/delta-pro-ultra',
            },
            {
                title_1: t('secE_item5_title_1'),
                title_2: t('secE_item5_title_2'),
                title_3: t('secE_item5_title_3'),
                title_4: t('secE_item5_title_4'),
                img: 'https://websiteoss.ecoflow.com/upload/image/1723023664330/DP3%2BSHP%20(1).png',
                targetElement: '.landing_page_GG',
                top: 52,
                // buyNowLink: 'https://ca.ecoflow.com/cart/44244774650010:1,44286204903578:1?channel=buy_button',
                buyNowLink: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384730266',
            },
            {
                title_1: t('secE_item1_title_1'),
                title_2: t('secE_item1_title_2'),
                title_3: t('secE_item1_title_3'),
                title_4: t('secE_item1_title_4'),
                img: 'pc/ef_1',
                targetElement: '.landing_page_G',
                top: 52,
                buyNowLink: starterKitBuyNow.replace('https://us', `https://${locale}`),
            },
            {
                title_1: t('secE_item2_title_1'),
                title_2: t('secE_item2_title_2'),
                title_3: t('secE_item2_title_3'),
                title_4: t('secE_item2_title_4'),
                img: 'pc/g-5',
                targetElement: '.landing_page_G',
                top: 52,
                buyNowLink: advencedKitBuyNow.replace('https://us', `https://${locale}`),
            },
            // {
            //     title_1: t('secE_item3_title_1'),
            //     title_2: t('secE_item3_title_2'),
            //     title_3: t('secE_item3_title_3'),
            //     title_4: t('secE_item3_title_4'),
            //     img: 'pc/e-1',
            //     targetElement: '.scroll-trigger-origin-H2',
            //     top: 52,
            //     buyNowLink: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
            // },
        ],
        sa: [
            {
                title_1: t('secE_item3_title_1'),
                title_2: t('secE_item3_title_2'),
                title_3: t('secE_item3_title_3'),
                title_4: t('secE_item3_title_4'),
                img: 'product/bundle_river2_pro_ts',
                targetElement: '.landing_page_R2PTSB',
                top: 0,
                buyNowLink: '',
            },
            {
                title_1: t('secE_item1_title_1'),
                title_2: t('secE_item1_title_2'),
                title_3: t('secE_item1_title_3'),
                title_4: t('secE_item1_title_4'),
                img: 'product/bundle_delta2_ts',
                targetElement: '.landing_page_D2TSB',
                top: 0,
                buyNowLink: '',
            },
            {
                title_1: t('secE_item2_title_1'),
                title_2: t('secE_item2_title_2'),
                title_3: t('secE_item2_title_3'),
                title_4: t('secE_item2_title_4'),
                img: 'product/bundle_delta_pro_ts',
                targetElement: '.landing_page_DPTSB',
                top: 0,
                buyNowLink: '',
            },
        ],
        za: [
            {
                title_1: t('secE_item1_title_1'),
                title_2: t('secE_item1_title_2'),
                title_3: t('secE_item1_title_3'),
                title_4: t('secE_item1_title_4'),
                img: 'product/bundle_river_pro_ts',
                targetElement: '.landing_page_R2PTSB',
                top: 0,
                buyNowLink: 'https://za.ecoflow.com/products/river-pro-portable-power-station',
            },
            {
                title_1: t('secE_item2_title_1'),
                title_2: t('secE_item2_title_2'),
                title_3: t('secE_item2_title_3'),
                title_4: t('secE_item2_title_4'),
                img: 'product/bundle_delta2_ts_za',
                targetElement: '.landing_page_D2TSB',
                top: 0,
                buyNowLink: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
            },
            {
                title_1: t('secE_item3_title_1'),
                title_2: t('secE_item3_title_2'),
                title_3: t('secE_item3_title_3'),
                title_4: t('secE_item3_title_4'),
                img: 'product/bundle_delta_pro_ts_za',
                targetElement: '.landing_page_DPTSB',
                top: 0,
                buyNowLink: 'https://za.ecoflow.com/products/delta-pro-portable-power-station',
            },
        ],
        au: [
            {
                title_1: t('secE_item1_title_1'),
                title_2: t('secE_item1_title_2'),
                title_3: t('secE_item1_title_3'),
                title_4: t('secE_item1_title_4'),
                img: 'product/R2+TS',
                targetElement: '.landing_page_R2PTSB',
                top: 0,
                buyNowLink: 'https://au.ecoflow.com/collections/ecoflow-river-series/products/river-2-pro-portable-power-station',
            },
            {
                title_1: t('secE_item2_title_1'),
                title_2: t('secE_item2_title_2'),
                title_3: t('secE_item2_title_3'),
                title_4: t('secE_item2_title_4'),
                img: 'product/D2+D2EB+TS',
                targetElement: '.landing_page_D2TSB',
                top: 0,
                buyNowLink: 'https://au.ecoflow.com/products/delta-2-portable-power-station',
            },
            {
                title_1: t('secE_item3_title_1'),
                title_2: t('secE_item3_title_2'),
                title_3: t('secE_item3_title_3'),
                title_4: t('secE_item3_title_4'),
                img: 'product/DP+TS',
                targetElement: '.landing_page_DPTSB',
                top: 0,
                buyNowLink: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
            },
        ],
    };
    const items = itemsMap[locale] || itemsMap.us;

    const getTop = (el: HTMLElement): number => {
        let cur = el as HTMLElement;

        let top = 0;
        while (cur) {
            top += cur.offsetTop;
            cur = cur.offsetParent as HTMLElement;
        }

        return top;
    };

    const getElementsTop = () => {
        items.forEach((item: any) => {
            const res = getTop(document.querySelector(item.targetElement) as HTMLElement);
            item.top = res;
        });
    };

    const handleClick = (item: any, index: number) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: t('secE_title'),
                product_name: item.title_2,
                button_name: t('learn_more'),
            });
        } catch (e) {
            console.log(e);
        }
        getElementsTop();
        const target = items[index].top;
        if (target == 0) return;
        window.scrollTo({
            top: target,
            behavior: 'smooth',
        });
    };

    const handleBuyNow = (item: any) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: item.title_2,
                position: `Solution Page_${t('secE_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
    };

    const handlePrev = () => {
        const liW = 376;
        const el = document.querySelector('.landing_page_E .listBox') as HTMLElement;
        if (el && disable !== 'prev') {
            if (Math.abs(parseInt(el.style.left)) <= 0) {
                return;
            }
            setLeft(`${parseInt(el.style.left) + liW}`);
            setDisable(Math.abs(parseInt(el.style.left) + liW) <= 0 ? 'prev' : '');
        }
    };

    const handleNext = () => {
        const liW = 376;
        const el = document.querySelector('.landing_page_E .listBox') as HTMLElement;
        if (el) {
            if (Math.abs(parseInt(el.style.left)) + window.innerWidth - 163 * 2 > el.offsetWidth) {
                return;
            }
            setLeft(`${parseInt(el.style.left) - liW}`);
            setDisable(Math.abs(parseInt(el.style.left) - liW) + window.innerWidth > el.offsetWidth ? 'next' : '');
        }
    };

    useEffect(() => {
        setTimeout(() => {
            getElementsTop();
        }, 10);
        const { layoutH } = useAnimate();

        const handleScroll = throttle(() => {
            const top = document.documentElement.scrollTop;
            const getTop: any = (el: any) => {
                let realTop = el?.offsetTop || 0;
                const parent = el?.parentElement || null;
                if (parent) {
                    return (realTop += getTop(parent));
                }
                return realTop;
            };

            // 大概位置并不精确
            let target1: HTMLElement;
            if (SHOW_TS_BUNDLE_SITE) {
                target1 = document.querySelector('.landing_page_R2PTSB') as HTMLElement;
            } else {
                target1 = document.querySelector('.landing_page_F') as HTMLElement;
            }
            if (top > getTop(target1) - layoutH / 2 && top < getTop(target1) + target1.offsetHeight - layoutH / 2) {
                setCurIndex(0);
            }

            if (locale === 'us') {
                const target2 = document.querySelector('.landing_page_F1') as HTMLElement;
                if (top > getTop(target2) - layoutH / 2 && top < getTop(target2) + target2.offsetHeight - layoutH / 2) {
                    setCurIndex(1);
                }

                const target3 = document.querySelector('.landing_page .section-special') as HTMLElement;
                if (top > getTop(target3) - layoutH / 2 && top < getTop(target3) + target3.offsetHeight - layoutH / 2) {
                    setCurIndex(2);
                }

                const target4 = document.querySelector('.landing_page .H2') as HTMLElement;
                if (top > getTop(target4) - layoutH / 2 && top < getTop(target4) + target4.offsetHeight - layoutH / 2) {
                    setCurIndex(3);
                }

                if (top > getTop(target4) + target4.offsetHeight - layoutH / 2) {
                    setCurIndex(4);
                }
            }
            if (locale === 'ca') {
                const t1 = document.querySelector('.landing_page .landing_page_F0') as HTMLElement;
                const t2 = document.querySelector('.landing_page .landing_page_GG') as HTMLElement;
                const t3 = document.querySelector('.landing_page .landing_page_F') as HTMLElement;
                const t4 = document.querySelector('.landing_page .landing_page_G') as HTMLElement;
                const t1Top = getTop(t1);
                const t2Top = getTop(t2);
                const t3Top = getTop(t3);
                if (top > t1Top - layoutH / 2 && top < t1Top + t1.offsetHeight - layoutH / 2) {
                    setCurIndex(0);
                }
                if (top > t2Top - layoutH / 2 && top < t2Top + t2.offsetHeight - layoutH / 2) {
                    setCurIndex(1);
                }
                if (top > t3Top - layoutH / 2 && top < t3Top + t3.offsetHeight - layoutH / 2) {
                    setCurIndex(2);
                }
                if (top > t3Top + t3.offsetHeight - layoutH / 2) {
                    setCurIndex(3);
                }
            }
            if (['sa', 'za', 'au'].includes(locale)) {
                const target2 = document.querySelector('.landing_page .landing_page_D2TSB') as HTMLElement;
                if (top > getTop(target2) - layoutH / 2 && top < getTop(target2) + target2.offsetHeight - layoutH / 2) {
                    setCurIndex(1);
                }

                if (top > getTop(target2) + target2.offsetHeight - layoutH / 2) {
                    setCurIndex(2);
                }
            }
        }, 50);

        const handleWindowResize = () => getElementsTop();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();
        if (locale === 'ca') {
            createScene({
                triggerElement: '.landing_page_F0',
                triggerHook: 1,
                offset: layoutH - 200,
                duration: 100000,
            })
                .setClassToggle('.secHFooter', locale === 'us' ? 'show_us' : 'show')
                .addTo(aniController);
        } else {
            createScene({
                triggerElement: '.landing_page_F',
                triggerHook: 1,
                offset: layoutH - 200,
                duration: 100000,
            })
                .setClassToggle('.secHFooter', locale === 'us' ? 'show_us' : 'show')
                .addTo(aniController);
        }

        createScene({
            triggerElement: locale === 'ca' ? '.landing_page_F0' : '.landing_page_F',
            triggerHook: 1,
            offset: layoutH - 200,
            duration: 100,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.secHFooter', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        createScene({
            triggerElement: '.landing_page_E',
            triggerHook: 1,
            offset: 0,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax()
                    .add(
                        TweenMax.to('.secHTitle', 1, {
                            opacity: 1,
                        }),
                        0,
                    )
                    .add(
                        TweenMax.to('.listBox', 1, {
                            opacity: 1,
                        }),
                        0,
                    ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    return (
        <div className={`landing_page_E ${css.landing_page_E}`}>
            <div className="secHTitle">{t('secE_title')}</div>
            <div
                className="listBox hidden-scrollbar"
                style={
                    locale === 'ca'
                        ? {
                              left: left + 'px',
                          }
                        : {}
                }
            >
                {items.map((item: any, index: number) => (
                    <div className="listItem" key={index}>
                        <div className="listItem_imgBox">
                            {String(item.img).startsWith('https://') ? (
                                <EfImg pc={item.img} />
                            ) : (
                                <EFPic name={[`${item.img}.png`, `${item.img}.png`]} alt={item.title_1} />
                            )}
                        </div>
                        <div className="listItem_title1">{item.title_1}</div>
                        <div className="listItem_title2">{item.title_2}</div>
                        <div className="listItem_title3">{item.title_3}</div>
                        <div className="listItem_title4">{item.title_4}</div>
                        <div className="listItem_btnBox">
                            <div className="listItem_btnLeft btnHover" onClick={() => handleClick(item, index)}>
                                {t('learn_more')}
                            </div>
                            {item.buyNowLink && (
                                <Link href={item.buyNowLink} target="blank">
                                    <div className="listItem_btnRight btnHover" onClick={() => handleBuyNow(item)}>
                                        {t('secE_buyNow')}
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            {locale === 'ca' && (
                <div className="btns">
                    <button className={`btn prev ${disable === 'prev' ? 'disable' : ''}`} onClick={handlePrev}>
                        <svg width="1em" height="1em" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="25" cy="25" r="24.5833" transform="matrix(-1 0 0 1 50 0)" fill="black" stroke="currentColor" strokeWidth="0.833333" />
                            <path
                                d="M27.5434 16.7754L19.7656 24.5532L27.5434 32.3309"
                                stroke="currentColor"
                                strokeWidth="2.04167"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <button className={`btn next ${disable === 'next' ? 'disable' : ''}`} onClick={handleNext}>
                        <svg width="1em" height="1em" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="25" cy="25" r="24.5833" fill="black" stroke="currentColor" strokeWidth="0.833333" />
                            <path
                                d="M22.4566 16.7754L30.2344 24.5532L22.4566 32.3309"
                                stroke="currentColor"
                                strokeWidth="2.04167"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            )}
            <div className="secHFooter">
                <div className="footerItemBox">
                    {items.map((item: any, index: number) => (
                        <div
                            key={index}
                            className={`footerItem footerItem_${index} ${curIndex == index ? 'active' : ''}`}
                            onClick={() => handleClick(item, index)}
                        >
                            <div>
                                <div className="secHFooterTitle">{item.title_1}</div>
                                <div className="secHFooterSubTitle">{locale === 'au' ? item.title_4.split('\n')[0] : item.title_4}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
